export const alertMessageForPublishedBattlecard = (title, published) => {
  const pStyle = 'font-style: normal; font-weight: 400; font-size: 18px;';

  return published ?
    `<strong>"${title}"</strong> is now available to your Consumer users.<br /><br />
    <i style="${pStyle}"}>Users whose visibility permissions match those of the Cards in this Battlecard
    will be able to see this Battlecard.</i>` :
      `<strong>"${title}"</strong> is now hidden from your Consumer users.<br /><br />
      <i style="${pStyle}"}>Card visibility permissions haven't changed, those that were
      visible in other Battlecards and this Board remain visible.</i>`;
};
